import { useState, useEffect, useCallback } from "react";
import api from "../lib/api";
import CrudPage from "../components/CrudPage";
import { StatCard } from "../components/StatCard";
import { Boxes, Wrench, PauseCircle, AlertTriangle } from "lucide-react";

const STATUS_OPTIONS = [
  { value: "kullanimda", label: "Kullanımda" },
  { value: "bakimda", label: "Bakımda" },
  { value: "bosta", label: "Boşta" },
  { value: "arizali", label: "Arızalı" },
];
const STATUS_LABELS = Object.fromEntries(STATUS_OPTIONS.map((o) => [o.value, o.label]));
const STATUS_STYLES = {
  kullanimda: "bg-emerald-50 text-emerald-600",
  bakimda: "bg-amber-50 text-amber-600",
  bosta: "bg-gray-100 text-gray-600",
  arizali: "bg-red-50 text-red-600",
};

export default function Equipment() {
  const [summary, setSummary] = useState(null);

  const loadSummary = useCallback(() => {
    api.get("/equipment/summary").then((r) => setSummary(r.data)).catch(() => {});
  }, []);

  useEffect(() => { loadSummary(); }, [loadSummary]);

  return (
    <CrudPage
      title="Envanter"
      subtitle="İşletmenize ait makine/ekipmanları ve adetlerini takip edin"
      module="equipment"
      endpoint="/equipment"
      addLabel="Yeni Ekipman"
      defaultValues={{ quantity: 1, status: "kullanimda" }}
      filters={[{ name: "status", label: "Durum", options: STATUS_OPTIONS }]}
      onChange={loadSummary}
      topContent={
        summary && (
          <div className="mb-6 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4" data-testid="equipment-summary">
            <StatCard testId="equipment-total-types" label="Ekipman Çeşidi" value={summary.total_types} icon={Boxes} />
            <StatCard testId="equipment-total-quantity" label="Toplam Adet" value={summary.total_quantity} icon={Wrench} accent />
            <StatCard testId="equipment-bakimda" label="Bakımda" value={summary.by_status.bakimda} icon={PauseCircle} />
            <StatCard testId="equipment-arizali" label="Arızalı" value={summary.by_status.arizali} icon={AlertTriangle}
              accent={summary.by_status.arizali > 0} />
          </div>
        )
      }
      columns={[
        { key: "name", label: "Ekipman Adı", render: (r) => <span className="font-medium">{r.name}</span> },
        { key: "brand", label: "Marka" },
        { key: "model", label: "Model" },
        { key: "quantity", label: "Miktar", render: (r) => <span className="font-semibold">{r.quantity}</span> },
        {
          key: "status", label: "Durum",
          render: (r) => (
            <span className={`px-2 py-1 text-xs font-semibold ${STATUS_STYLES[r.status] || ""}`}>
              {STATUS_LABELS[r.status] || "-"}
            </span>
          ),
        },
        { key: "serial_no", label: "Seri No" },
        { key: "location", label: "Konum" },
        { key: "purchase_date", label: "Satın Alma", render: (r) => r.purchase_date || "-" },
      ]}
      fields={[
        { name: "name", label: "Ekipman Adı/Türü", required: true },
        { name: "quantity", label: "Miktar", type: "number", required: true },
        { name: "brand", label: "Marka" },
        { name: "model", label: "Model" },
        { name: "status", label: "Durum", type: "select", options: STATUS_OPTIONS },
        { name: "serial_no", label: "Seri No" },
        { name: "location", label: "Konum" },
        { name: "purchase_date", label: "Satın Alma Tarihi", type: "date" },
        { name: "note", label: "Not", type: "textarea", colSpan: 2 },
      ]}
    />
  );
}
